// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TrackingPlatform } from '@ys/web-common-repo/dist/lib/trace/index';

const getEnv = () => {
  // 从环境变量获取自定义API环境
  const customEnv = process.env.CUSTOM_API_ENV || 'development';

  switch (customEnv) {
    case 'prod':
    case 'production':
      return 'prod';
    case 'dev':
    case 'development':
    default:
      return 'dev';
  }
};
// 埋点配置
const ENV = getEnv();

// 不同环境的埋点配置，支持通过环境变量覆盖
const envConfigs = {
  dev: {
    aliProps: {
      appKey: '0k5vbpyasya6r1fv60dl1n5o',
      trackDomain: 'https://quicktracking-qlc-ap-southeast.alibabacloud.com',
      sdkUrl: 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.cjs.js',
      globalProperty: {
        environment: 'dev',
      },
    },
    platforms: [TrackingPlatform.ALI],
  },
  prod: {
    aliProps: {
      appKey: '3jdp6m4ms3ctmasxlhvu2arv',
      trackDomain: 'https://quicktracking-qlc-ap-southeast.alibabacloud.com',
      sdkUrl: 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.cjs.js',
      globalProperty: {
        environment: 'prod',
      },
    },
    platforms: [TrackingPlatform.ALI],
  },
} as const;

const base = envConfigs[ENV];
const trackingConfig = {
  ...base,
  platforms: [...base.platforms],
};

// 创建埋点实例
export const createTracker = async () => {
  const Tracker = (await import('@ys/web-common-repo/dist/lib/trace/index'))
    .default;

  return new Tracker(trackingConfig);
};

// 导出配置
export { trackingConfig };
